<template>
  <el-dialog
    v-loading="isLoading"
    :visible="isOpen"
    :close-on-click-modal="!isLoading"
    :close-on-press-escape="!isLoading"
    :before-close="handleClose"
    :show-close="false"
    :title="$t('hardcode.offlineProduct')"
    width="40%"
    top="6vh"
  >
    <span>{{ $t('hardcode.offlineFollowingProduct') }}:</span>
    <generic-form
      ref="form"
      :attributes="{ disabled: isLoading, labelWidth: '89px' }"
      :form="form"
      :form-template="offlineProductTemplate"
      :border="false"
      class="pb-3"
    />

    <span
      slot="footer"
    >
      <el-button
        :disabled="isLoading"
        class="mr-1"
        @click="handleClose"
      >{{ $t('button.cancel') }}</el-button>

      <el-popconfirm
        :cancel-button-text="$t('button.cancel')"
        :confirm-button-text="$t('button.delete')"
        title="Are you sure to delete this?"
        @onConfirm="handleConfirm"
      >
        <el-button
          slot="reference"
          :disabled="isLoading || !isValidForm"
          type="danger"
        >{{ $t('button.confirm') }}</el-button>
      </el-popconfirm>
    </span>
  </el-dialog>
</template>

<script>
import {
  createComponent,
  ref,
  reactive,
  watch,
} from '@vue/composition-api'

import GenericForm from '@/components/form/Form.vue'

import HardcodeProductService from '../../../../api/hardcode-product'
import { offlineProductTemplate } from '../../../../const/product'

const OfflineProductDialog = createComponent({
  components: {
    GenericForm,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const { emit, refs, root } = context
    const isLoading = ref(false)
    const isValidForm = ref(false)

    const form = reactive({
      product_id: '',
    })
    watch(() => form.product_id, () => {
      if (!refs.form) return

      refs.form.$refs.form.validate().then(() => {
        isValidForm.value = true
      }).catch(() => {
        isValidForm.value = false
      })
    })

    const handleClose = () => {
      emit('close')
    }
    const handleConfirm = () => {
      isLoading.value = true
      HardcodeProductService.delete(form.product_id).then(() => {
        root.$message.success({
          message: root.$t('hardcode.productOfflineSuccessfully', { productId: form.product_id }),
          duration: 5000,
          showClose: true,
        })
        handleClose()
      }).finally(() => {
        isLoading.value = false
      })
    }

    return {
      isLoading,
      isValidForm,

      offlineProductTemplate,
      form,

      handleClose,
      handleConfirm,
    }
  },
})

export default OfflineProductDialog
</script>
